import { createGlobalStyle } from 'styled-components';

export const AppContentWrapperStyles = createGlobalStyle<{ customThemeFonts?: string[] | null }>`
  body {
    font-family: ${({ theme, customThemeFonts }) => customThemeFonts?.join() || theme.fonts.join()};
  }
`;
